<template>
  <div class="home">
    <div v-if="!loading">
      <progressIndicator />
      <articleHeaderComponent :data="getArticle" />
      <articleBody :data="getArticle" />
      <articlesList />
      <newsLetterComponent />
      <footerComponent />
    </div>
    <div v-else>
      <loadingComponent />
    </div>
  </div>
</template>

<script>
import articleHeaderComponent from "@/components/articleHeaderComponent.vue";
import articleBody from "@/components/articleBody.vue";
import progressIndicator from "@/components/progressIndicator.vue";
import articlesList from "@/components/articlesList.vue";
import loadingComponent from "@/components/loadingComponent.vue";
import footerComponent from "@/components/footerComponent.vue";
import { mapGetters, mapMutations } from "vuex";
import axios from "axios";
import { useHead } from "@unhead/vue";
import newsLetterComponent from "@/components/newsLetterComponent.vue";

export default {
  name: "ArticleView",
  components: {
    articleHeaderComponent,
    progressIndicator,
    articleBody,
    articlesList,
    loadingComponent,
    newsLetterComponent,
    footerComponent,
  },
  computed: {
    ...mapGetters(["getArticle"]),
  },
  data() {
    return {
      loading: true,
    };
  },
  watch: {
    $route() {
      this.getCoursesFromSlug();
    },
  },
  beforeMount() {
    useHead({
      title: `Comligo Spanish - ${this.capitalizeWords(
        this.$route.params.id.replaceAll("-", " ")
      )}`,
      link: [
        { rel: "canonical", href: `https://comligo.com${this.$route.path}` },
      ],
    });
  },
  mounted() {
    this.getCoursesFromSlug();
    this.getArticlesData();
  },
  methods: {
    ...mapMutations(["setArticle", "setBreadcrumbs", "setArticles"]),
    getArticleData() {
      this.loading = true;
      axios
        .get(
          `https://cdn.contentful.com/spaces/8nqnktj51aoq/environments/master/entries/${this.$route.params.id}?access_token=njkIU16uuU7MPa5hOvzUO4deV6DFYht3xdwj6KUge-k`
        )
        .then((response) => {
          this.setArticle(response.data);
          this.loading = false;
          this.scrollToTop();
          this.setBreadcrumbs([
            {
              title: "Home",
              disabled: false,
              href: "/",
            },
            {
              title: "Articles",
              disabled: false,
              href: "/spanish-learning-articles",
            },
            {
              title: this.getArticle?.fields?.title,
              disabled: false,
              href: `/article/${this.$route.params.id}`,
            },
          ]);
        })
        .catch(() => {
          this.$router.push("/404");
          this.loading = false;
        });
    },
    getCoursesFromSlug() {
      this.loading = true;
      axios
        .get(`https://cdn.contentful.com/spaces/8nqnktj51aoq/entries`, {
          params: {
            access_token: "njkIU16uuU7MPa5hOvzUO4deV6DFYht3xdwj6KUge-k",
            content_type: "blog",
            "fields.slug": this.$route?.params?.id, // Query by the slug field
          },
        })
        .then((response) => {
          if (response?.data?.items.length > 0) {
            this.setArticle(response?.data?.items[0]);
            this.loading = false;
          } else {
            this.getArticleData();
          }
          this.scrollToTop();
          this.setBreadcrumbs([
            {
              title: "Home",
              disabled: false,
              href: "/",
            },
            {
              title: "Articles",
              disabled: false,
              href: "/spanish-learning-articles",
            },
            {
              title: this.getArticle?.fields?.title,
              disabled: false,
              href: `/article/${this.$route.params.id}`,
            },
          ]);
          const firstParagraph = this.getArticle?.fields?.paragraphs?.content
            ?.filter((p) => p.nodeType === "paragraph")
            ?.filter((p) => p?.content[0].value);
          useHead({
            title: `Comligo Spanish - ${
              this.getArticle?.fields?.metaTitle ||
              this.capitalizeWords(this.$route.params.id.replaceAll("-", " "))
            }`,
            meta: [
              {
                name: "description",
                content:
                  this.getArticle?.fields?.metaDescription ||
                  firstParagraph?.length > 0
                    ? `${this.getArticle?.fields?.title}: ${firstParagraph[0]?.content[0]?.value}`
                    : this.capitalizeWords(
                        this.$route.params.id.replaceAll("-", " ")
                      ),
              },
            ],
            link: [
              {
                rel: "canonical",
                href: `https://comligo.com${this.$route.path}`,
              },
            ],
          });
        })
        .catch(() => {
          this.getArticleData();
        });
    },
    capitalizeWords(str) {
      return str
        .split(" ")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ");
    },
    getArticlesData() {
      this.setArticles([]);
      axios
        .get(
          "https://cdn.contentful.com/spaces/8nqnktj51aoq/environments/master/entries?access_token=njkIU16uuU7MPa5hOvzUO4deV6DFYht3xdwj6KUge-k&content_type=blog&limit=3"
        )
        .then((response) => {
          this.setArticles(response.data.items);
        });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
